import { LazyLoadUtils } from "../../utils/index.js";

export const LeftAreaPC = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "menu/pc/left-area" */
      "./LeftAreaPC.js"
    ),
  { componentName: "LeftAreaPC" }
);

export const MenuChunk = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "menu/pc/menu" */
      "../Menu/Menu.js"
    ),
  { componentName: "Menu" }
);
